import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className='text-center'>404 NOT FOUND</h1>
        </div>
    );
};

export default NotFound;